import React from 'react';
import { Button as MButton, CircularProgress } from '@material-ui/core';
import PropTypes from 'prop-types';
import useStyles, { useOtherStyles } from './styles';

const Button = (props) => {
    const classes = useStyles();
    const otherClasses = useOtherStyles();

    const { loading, disabled } = props;
    const rest = { ...props };
    delete rest.loading;
    return (
        <div className={otherClasses.wrapper}>
            <MButton classes={classes} {...rest} disabled={loading || disabled}>
                <>
                    {props.children}
                    {loading && (
                        <CircularProgress
                            size={20}
                            className={otherClasses.buttonProgress}
                        />
                    )}
                </>
            </MButton>
        </div>
    );
};

Button.propTypes = {
    children: PropTypes.any,
    loading: PropTypes.bool,
};

Button.defaultProps = {
    children: null,
    loading: false,
};

export default Button;
